import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles/index';

import {isAuthenticated} from '../helpers/auth.helper';

const styles = {
    root: {
        width: '100%',
    },
    flex: {
        flex: 1
    }
};

class Header extends Component {

    render() {
        return (
            <div className={this.props.classes.root}>
                <AppBar position="static" color="default" className={this.props.className}>
                    <Toolbar>
                        <IconButton aria-label="Menu" onClick={this.props.onToggle}>
                            <MenuIcon/>
                        </IconButton>
                        <Typography variant="title" color="inherit" className={this.props.classes.flex}>Monitor Backup</Typography>
                        {isAuthenticated() ? <Button type="button" component={Link} to={'/logout'}>Sair</Button> : null}
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// src/components/Header.js